export default __webpack_public_path__ + "static/media/pin-alt.e3fd62c7.svg";